<template>
  <DrawerContainer
    ref="drawerContainer"
    :dialogShow="dialogShow"
    v-if="dialogShow"
    :dialog-width="'40%'"
    :title="dialogTile"
    @resetPopupData="resetDrawer"
    @submitPopupData="submitForm"
  >
    <div class="driver-box custom-form" v-loading="loading">
      <el-form ref="form" :model="form" :rules="rules" label-position="top">
        <div class="right-title">
          <el-image :src="cheImage" class="title-label"></el-image>司机信息
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="司机姓名" prop="username">
              <el-input
                v-model="form.username"
                clearable
                autocomplete="off"
                maxlength="30"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="phone">
              <el-input
                v-model="form.phone"
                clearable
                autocomplete="off"
                maxlength="11"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属机构" prop="companyId">
              <el-select
                :disabled="isEdit"
                style="width: 100%"
                v-model="form.companyId"
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in companyList"
                  :key="item.companyId"
                  :label="item.companyName"
                  :value="item.companyId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="关联车队长" prop="vehicleLeaderId">
              <el-select
                style="width: 100%"
                v-model="form.vehicleLeaderId"
                filterable
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in vehicleLeaderData"
                  :key="item.userId"
                  :label="item.username"
                  :value="item.userId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="常驻地址" prop="addressDot">
              <el-cascader
                key="el3"
                style="width: 100%"
                :options="options"
                ref="cascaderEnd"
                @change="handleChangeAddress"
                v-model="form.addressDot"
                :props="cityProps"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="运输线路" prop="lineType">
              <el-radio-group v-model="form.lineType">
                <el-radio :label="1">常跑线路</el-radio>
                <el-radio :label="2">漫游线路</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.lineType === 1">
            <el-form-item label="常跑线路" prop="lineId">
<!--            平台司机入驻时，运输线路改为非必填，名称改为常跑线路-->
<!--            <el-form-item label="常跑线路">-->
              <el-select
                style="width: 100%"
                v-model="form.lineId"
                filterable
                allow-create
                default-first-option
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in lineData"
                  :key="item.lineId"
                  :label="`${item.startCityName}
                  -
                  ${item.endCityName}`"
                  :value="item.lineId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="right-title">
          <el-image :src="cheImage" class="title-label"></el-image>司机信息
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="车牌号码" prop="carNumber">
              <custom-car-number v-model="form.carNumber"></custom-car-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车牌类型" prop="carNumberType">
              <el-select
                style="width: 100%"
                v-model="form.carNumberType"
                filterable
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in getConfig('car_number_type')"
                  :key="item.dictLabel"
                  :label="item.dictLabel"
                  :value="item.dictLabel"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车辆使用性质" prop="vehicleUseType">
              <el-select
                style="width: 100%"
                v-model="form.vehicleUseType"
                filterable
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in getConfig('vehicle_function')"
                  :key="item.dictLabel"
                  :label="item.dictLabel"
                  :value="item.dictLabel"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车型" prop="vehicleMode">
              <el-select
                style="width: 100%"
                v-model="form.vehicleMode"
                filterable
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in getConfig('vehicle_mode')"
                  :key="item.dictLabel"
                  :label="item.dictLabel"
                  :value="item.dictLabel"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="体积" prop="volume">
              <el-input
                v-model="form.volume"
                clearable
                type="number"
                autocomplete="off"
                placeholder="请输入"
              ><template slot="append">方</template></el-input
              >
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车长" prop="vehicleLength">
              <el-select
                style="width: 100%"
                v-model="form.vehicleLength"
                filterable
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in getConfig('vehicle_length')"
                  :key="item.dictLabel"
                  :label="item.dictLabel + '米'"
                  :value="item.dictLabel"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="承重" prop="loadBearing">
              <el-input
                v-model="form.loadBearing"
                clearable
                type="number"
                autocomplete="off"
                placeholder="请输入"
                ><template slot="append">吨</template></el-input
              >
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车宽" prop="vehicleWidth">
              <el-input
                v-model="form.vehicleWidth"
                clearable
                type="number"
                autocomplete="off"
                placeholder="请输入"
                ><template slot="append">米</template></el-input
              >
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车高" prop="vehicleHeight">
              <el-input
                v-model="form.vehicleHeight"
                clearable
                type="number"
                autocomplete="off"
                placeholder="请输入"
                ><template slot="append">米</template></el-input
              >
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开门方式" prop="openMethod">
              <el-select
                style="width: 100%"
                v-model="form.openMethod"
                filterable
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in getConfig('open_method')"
                  :key="item.dictLabel"
                  :label="item.dictLabel"
                  :value="item.dictLabel"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>


          <el-col :span="12">
            <el-form-item label="GPS" prop="gpsId">
              <el-input
                v-model="form.gpsId"
                clearable
                autocomplete="off"
                placeholder="请输入ID"
              >
                <span  slot="prepend">S/N:</span>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否有尾板" prop="tailBoard">
              <el-radio-group v-model="form.tailBoard">
                <el-radio label="是">是</el-radio>
                <el-radio label="否">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="right-title">
          <el-image :src="cheImage" class="title-label"></el-image>三证材料
        </div>
        <el-row :gutter="20">
          <div class="photo-box">
            <div class="photo-list">
              <el-form-item prop="vehicleLicenceId" label="行驶证">
                <!--                <div class="photo-title">行驶证</div>-->
                <upload-files1 v-model="form.vehicleLicenceId"></upload-files1>
              </el-form-item>
            </div>

            <div class="photo-list">
              <el-form-item prop="drivingLicenceId" label="驾驶证">
                <!--                <div class="photo-title">驾驶证</div>-->
                <upload-files1 v-model="form.drivingLicenceId"></upload-files1>
              </el-form-item>
            </div>

            <div class="photo-list">
              <el-form-item prop="idCardId" label="身份证">
                <!--                <div class="photo-title">身份证</div>-->
                <upload-files1 v-model="form.idCardId"></upload-files1>
              </el-form-item>
            </div>
          </div>
        </el-row>
<!--        <div class="right-title">-->
<!--          <el-image :src="cheImage" class="title-label"></el-image>上线付款证明-->
<!--        </div>-->
<!--        <el-row :gutter="20">-->
<!--          <el-col :span="6">-->
<!--            <el-form-item label="管理费实缴" prop="managementFee">-->
<!--              <el-input-->
<!--                v-model="form.managementFee"-->
<!--                clearable-->
<!--                autocomplete="off"-->
<!--                placeholder="请输入"-->
<!--              >-->
<!--                <template slot="append">元</template>-->
<!--              </el-input>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="6">-->
<!--            <el-form-item label="保险实缴" prop="premium">-->
<!--              <el-input-->
<!--                v-model="form.premium"-->
<!--                clearable-->
<!--                autocomplete="off"-->
<!--                placeholder="请输入"-->
<!--                ><template slot="append">元</template></el-input-->
<!--              >-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="6">-->
<!--            <el-form-item label="GPS实缴" prop="account">-->
<!--              <el-input-->
<!--                v-model="form.gpsFee"-->
<!--                clearable-->
<!--                autocomplete="off"-->
<!--                placeholder="请输入"-->
<!--                ><template slot="append">元</template></el-input-->
<!--              >-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="6">-->
<!--            <el-form-item label="上线费实缴" prop="onlineFee">-->
<!--              <el-input-->
<!--                v-model="form.onlineFee"-->
<!--                clearable-->
<!--                autocomplete="off"-->
<!--                placeholder="请输入"-->
<!--                ><template slot="append">元</template></el-input-->
<!--              >-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="24">-->
<!--            <el-form-item label="缴费备注" prop="remark">-->
<!--              <el-input-->
<!--                v-model="form.remark"-->
<!--                clearable-->
<!--                autocomplete="off"-->
<!--                rows="3"-->
<!--                type="textarea"-->
<!--                show-word-limit-->
<!--                maxlength="50"-->
<!--                placeholder="请输入"-->
<!--              />-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="24">-->
<!--            <el-form-item label="上线付款凭证" prop="feeVouchers">-->
<!--              <upload-files4 v-model="form.feeVouchers"></upload-files4>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--        </el-row>-->
      </el-form>
    </div>
  </DrawerContainer>
</template>

<script>
import DrawerContainer from "@/components/Drawer.vue";
import CustomCarNumber from "@/components/CustomCarNumber.vue";
import { validatePhone, validatePrice } from "@/utils/validate";
import { getSelectCompany } from "@/views/SystemManagement/CompanyManagement/api";
import { getAreaNext, getCheDuiZhang, getDispatchers } from "@/views/commonApi";
import { getConfig } from "@/utils/localDict";
import { getBaseLine } from "@/views/ServiceConfig/CarrierRouteConfig/api";
import uploadFiles4 from "@/components/UploadFiles4.vue";
import UploadFiles1 from "@/components/UploadFiles1.vue";
import { detailInfo } from "./api";
import {
  editDriverInfo,
  saveDriverInfo,
} from "@/views/FleetLeaderWorkbench/PlatformDriverManagement/api";
import { setAreaTree } from "@/utils";
export default {
  name: "AddOrEdit",
  components: {
    UploadFiles1,
    DrawerContainer,
    uploadFiles4,
    CustomCarNumber,
  },
  data() {
    return {
      dialogShow: false,
      cheImage: require("@/assets/imgs/title.png"),
      cityProps: {
        value: "areaCode",
        label: "areaExtName",
        checkStrictly: true,
      },
      // cityProps: {
      //   lazy: true,
      //   checkStrictly: true, //可选择任意节点
      //   lazyLoad(node, resolve) {
      //     // setTimeout(() => {
      //     const nodes = [];
      //     let query = {};
      //     // 构造查询条件
      //     if (node.value) {
      //       query = {
      //         code: node.value,
      //       };
      //     }
      //     //查询接口
      //     getAreaNext(query).then((res) => {
      //       res.data.map((item) => {
      //         let obj = {
      //           value: item.areaCode,
      //           label: item.areaName,
      //           leaf: item.areaLevel === 2,
      //           disabled: item.areaLevel <= 1,
      //         };
      //         nodes.push(obj);
      //       });
      //       //重新加载节点
      //       resolve(nodes);
      //     });
      //     // }, 500);
      //   },
      // },
      form: {
        carNumber: "",
        companyId: "",
        dispatcherId: "",
        drivingLicenceId: "",
        addressDot: [],
        feeVouchers: [],
        gpsFee: "",
        gpsId: "",
        driverId: "",
        idCardId: "",
        lineId: "",
        lineType: 1,
        loadBearing: "",
        managementFee: "",
        onlineFee: "",
        phone: "",
        carNumberType: "",
        vehicleHeight: "",
        vehicleWidth: "",
        openMethod: "",
        tailBoard: "是",
        premium: "",
        remark: "",
        username: "",
        vehicleLeaderId: "",
        vehicleLength: "",
        vehicleLicenceId: "",
        vehicleMode: "",
        volume: "",
        vehicleUseType: "",
        provinceCode: "",
        provinceName: "",
        districtName: "",
        districtCode: "",
        cityCode: "",
        cityName: "",
      },
      // form: {
      //   carNumber: "京C00000",
      //   companyId: "1916522121215868928",
      //   dispatcherId: "",
      //   drivingLicenceId: "1916853584931061760",
      //   addressDot: ["11", "1101", "110101"],
      //   feeVouchers: [
      //     { fileId: "1916853649376542720", filename: "1744423368604.png" },
      //   ],
      //   gpsFee: "444",
      //   gpsId: "2222222222222222",
      //   idCardId: "1916853595215495168",
      //   lineId: "1916853065617506304",
      //   lineType: 1,
      //   loadBearing: "22",
      //   managementFee: "222",
      //   onlineFee: "555",
      //   phone: "15928686000",
      //   carNumberType: "黄牌",
      //   premium: "333",
      //   remark:
      //     "缴费备注缴费备注缴费备注缴费备注缴费备注缴费备注缴费备注缴费备注缴费备注缴费备注缴费备注缴费备注缴费",
      //   username: "王大帅",
      //   vehicleLeaderId: "1916682410271965184",
      //   vehicleLength: "1.8",
      //   vehicleLicenceId: "1916853568183205888",
      //   vehicleMode: "依维柯",
      //   volume: "22",
      //   vehicleUseType: "整车",
      //   provinceCode: "11",
      //   provinceName: "北京",
      //   districtName: "东城",
      //   districtCode: "110101",
      //   cityCode: "1101",
      //   cityName: "北京",
      // },
      rules: {
        username: [{ required: true, message: "司机姓名不能为空" }],
        lineType: [{ required: true, message: "线路类型不能为空" }],
        phone: [
          { required: true, message: "联系方式不能为空" },
          { validator: validatePhone, trigger: "blur" },
        ],
        carNumber: [{ required: true, message: "车牌号不能为空" }],
        companyId: [{ required: true, message: "所属机构不能为空" }],
        vehicleLeaderId: [{ required: true, message: "车队长不能为空" }],
        addressDot: [{ required: true, message: "常驻地址不能为空" }],
        volume: [{ required: true, message: "体积不能为空" }],
        loadBearing: [{ required: true, message: "承重不能为空" }],
        vehicleLength: [{ required: true, message: "车长不能为空" }],
        vehicleMode: [{ required: true, message: "车型不能为空" }],
        vehicleLicenceId: [{ required: true, message: "上传行驶证" }],
        idCardId: [{ required: true, message: "身份证驶证" }],
        drivingLicenceId: [{ required: true, message: "驾驶证行驶证" }],
        openMethod: [{ required: true, message: "开门方式不能为空" }],
        vehicleWidth: [{ required: true, message: "车宽不能为空" }],
        vehicleHeight: [{ required: true, message: "车高不能为空" }],
        tailBoard: [{ required: true, message: "是否有尾板不能为空" }],
        managementFee: [
          { required: true, message: "管理费不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        premium: [
          { required: true, message: "保险费不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        gpsFee: [
          { required: true, message: "GPS费不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        onlineFee: [
          { required: true, message: "上线费用不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        carNumberType: [{ required: true, message: "车牌类型不能为空" }],
        vehicleUseType: [{ required: true, message: "车辆使用性质不能为空" }],
        lineId: [{ required: true, message: "线路不能为空" }],
      },
      companyList: [], // 公司
      vehicleLeaderData: [], // 车队长
      lineData: [], // 线路
      vehicleModel: ["黄牌", "绿牌"], // 车型枚举
      loading: false, // loading
      userInfo: JSON.parse(localStorage.getItem("u")),
      dialogTile: "司机入驻",
      isEdit: false
    };
  },
  watch: {
    "form.companyId": function (val) {
      if (val) {
        // this.getLineData(val);
        this.getCheDuiZhang(val);
      } else {
        this.lineId = "";
        this.vehicleLeaderId = "";
        this.lineData = [];
        this.vehicleLeaderData = [];
      }
    },
  },
  computed: {
    options: function() {
      let treeData = JSON.parse(localStorage.getItem("area")) || []
      return setAreaTree(treeData, 2)
    }
  },
  mounted() {},
  methods: {
    getConfig,
    resetDrawer() {
      this.dialogShow = false;
      this.form = this.$options.data().form;
      if (this.$refs.form) this.$refs.form.resetFields();
    },
    // 获取公司
    getSelectCompany() {
      getSelectCompany().then((res) => {
        if (res.code === 200) {
          this.companyList = res.data;
        }
      });
    },
    // 获取公司下线路
    getLineData(val) {
      getBaseLine(val).then((res) => {
        if (res.code === 200) {
          this.lineData = res.data;
        }
      });
    },
    // 获取公司下车队长
    getCheDuiZhang(val) {
      getCheDuiZhang(val).then((res) => {
        if (res.code === 200) {
          this.vehicleLeaderData = res.data;
        }
      });
    },
    getDetail(driverId) {
      this.loading = true
      detailInfo(driverId).then((res) => {
        if (res.code === 200) {
          // this.form = res.data;
          let arr = [
            res.data.provinceCode,
            res.data.cityCode,
            res.data.districtCode,
          ];
          // this.form.addressDot = [...arr];
          this.$set(this.form, "addressDot", arr);
          this.form.carNumber = res.data.carNumber;
          this.form.companyId = res.data.companyId;
          this.form.dispatcherId = res.data.dispatcherId;
          this.form.drivingLicenceId = res.data.drivingLicenceId;
          this.form.feeVouchers = res.data.feeVouchers;
          this.form.gpsFee = res.data.gpsFee;
          this.form.driverId = res.data.driverId;
          this.form.gpsId = res.data.gpsId;
          this.form.idCardId = res.data.idCardId;
          this.form.lineId = res.data.lineId;
          this.form.lineType = res.data.lineType;
          this.form.loadBearing = res.data.loadBearing;
          this.form.managementFee = res.data.managementFee;
          this.form.onlineFee = res.data.onlineFee;
          this.form.phone = res.data.phone;
          this.form.carNumberType = res.data.carNumberType;
          this.form.premium = res.data.premium;
          this.form.remark = res.data.remark;
          this.form.username = res.data.username;
          this.form.vehicleLeaderId = res.data.vehicleLeaderId;
          this.form.vehicleLength = res.data.vehicleLength;
          this.form.tailBoard = res.data.tailBoard;
          this.form.vehicleWidth = res.data.vehicleWidth;
          this.form.vehicleHeight = res.data.vehicleHeight;
          this.form.openMethod = res.data.openMethod;
          this.form.vehicleLicenceId = res.data.vehicleLicenceId;
          this.form.vehicleMode = res.data.vehicleMode;
          this.form.volume = res.data.volume;
          this.form.vehicleUseType = res.data.vehicleUseType;
          this.form.provinceCode = res.data.provinceCode;
          this.form.provinceName = res.data.provinceName;
          this.form.districtName = res.data.districtName;
          this.form.districtCode = res.data.districtCode;
          this.form.cityCode = res.data.cityCode;
          this.form.cityName = res.data.cityName;

          // this.$set(this.form, "addressDot", arr);
          // ;
          // // // console.log("this.form.addressDot", this.form.addressDot);
          // this.$forceUpdate();
        }
      }).finally(()=>{

        this.loading = false
      });
    },
    init(row) {
      this.getSelectCompany();
      this.getLineData();
      this.isEdit = false
      if (!!row) {
        this.getDetail(row.driverId);
        this.isEdit = true
        this.dialogTile = "编辑司机"
      } else {
        this.form.driverId = "";
        this.form.companyId = this.userInfo.companyId;
        this.dialogTile = "司机入驻"
      }

      this.dialogShow = true;
    },
    handleChangeAddress() {
      // 可以通过 this.$refs.cascader.getCheckedNodes() 获取选中的节点信息
      this.form.provinceCode = "";
      this.form.provinceName = "";
      this.form.cityCode = "";
      this.form.cityName = "";
      this.form.districtCode = "";
      this.form.districtName = "";
      const nodes = this.$refs.cascaderEnd.getCheckedNodes();
      nodes[0].pathNodes.forEach((node, index) => {
        if (index === 0) {
          this.form.provinceCode = node.value;
          this.form.provinceName = node.label;
        } else if (index === 1) {
          this.form.cityCode = node.value;
          this.form.cityName = node.label;
        } else if (index === 2) {
          this.form.districtCode = node.value;
          this.form.districtName = node.label;
        }
      });
      // // console.log("选中的名称end:", this.end);
    },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$refs.drawerContainer.loading = true;
          let methodName = "";
          if (this.form.driverId) {
            methodName = editDriverInfo;
          } else {
            methodName = saveDriverInfo;
          }
          methodName(this.form)
            .then((res) => {
              this.$refs.drawerContainer.loading = false;
              if (res.code === 200) {
                this.$message.success(
                  this.form.driverId ? "编辑成功" : "保存成功"
                );
                this.$parent.handleAddOrEditSuccess(this.form.driverId ? "edit" : "add");
                this.dialogShow = false;
              }
            })
            .catch((e) => {
              this.$refs.drawerContainer.loading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.driver-box {
  box-sizing: border-box;
  .right-title {
    padding: 0rem 0 0.2rem;
    .title-label {
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.06rem;
    }
  }
  .photo-box {
    display: flex;
    .photo-list {
      margin-left: 0.2rem;
      .photo-title {
        color: #8c8c8c;
        font-size: 0.12rem;
        line-height: 0.2rem;
        padding-bottom: 0.1rem;
      }
    }
  }
}
</style>
